import { FiTarget, FiEye } from 'react-icons/fi'
import type { OrgValue, Pillar } from '@/types/about'

export const orgValues: OrgValue[] = [
  {
    name: 'Transparency',
    detail: 'Built on a foundation of openness and accountability.',
  },
  {
    name: 'Innovation',
    detail: 'Embracing creativity and innovation to drive progress.',
  },
  {
    name: 'Teamwork',
    detail: 'Collaborating with partners and stakeholders to achieve shared goals.',
  },
]

export const pillars: Pillar[] = [
  {
    no: '01',
    label: 'Our Mission',
    title: 'Turning ideas into tangible solutions.',
    description:
      'To cultivate a collaborative ecosystem where groundbreaking ideas are transformed into tangible solutions, driving economic growth, enhancing quality of life, and celebrating the diversity of African and Caribbean cultures.',
    Icon: FiTarget,
  },
  {
    no: '02',
    label: 'Our Vision',
    title: 'Inclusive, sustainable growth for all.',
    description:
      'To transform ideas into sustainable business and inclusive socio-economic growth, empowering communities and fostering a brighter future for all.',
    Icon: FiEye,
  },
]
